@switch (selectedTool$ | async) {
  @case ('Edit') {
    <h3-edit-tool-3d-secondary-toolbar></h3-edit-tool-3d-secondary-toolbar>
  }
  @case ('Measure') {
    <h3-measure-tool-3d-secondary-toolbar></h3-measure-tool-3d-secondary-toolbar>
  }
}
